import React from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Header from "./Components/Header";
import Home from "./Pages/Home";
import AgeVerificationPopup from "./Components/AgeVerificationPopup";
import Footer from "./Components/Footer";
import About from "./Pages/About";
import Gallery from "./Pages/Gallery";
import Contact from "./Pages/Contact";
import Products from "./Pages/Products";
import ScrollToTop from "./Components/ScrollToTop";

const App = () => {
  return (
    <>
      <Header />
      <AgeVerificationPopup />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<Products />} />
      </Routes>
      <Footer />
      <ToastContainer position="top-center" autoClose={3000} />
    </>
  );
};

export default App;
